export const NOTIFY = 'NOTIFY';
export const NOTIFY_SUCCESS = 'NOTIFY_SUCCESS';
export const NOTIFY_FAILED = 'NOTIFY_FAILED';

export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const GET_NOTIFICATIONS_SUCCESS = 'GET_NOTIFICATIONS_SUCCESS';
export const GET_NOTIFICATIONS_FAILED = 'GET_NOTIFICATIONS_FAILED';